<template>
  <div>
    <div>
      <form-wizard
        @on-complete="saveContract"
        title
        subtitle
        color="#8cc63f"
        finish-button-text="Submit"
        shape="square"
      >
        <tab-content title="Contract Details" icon="ti-receipt">
          <div
            style="
              display: flex;
              align-items: center;
              margin-top: 20px;
              flex-direction: column;
            "
          >
            <div
              v-if="
                formType == 'update' ||
                selectedInvestor != null ||
                selectedProject != null
              "
              class="col-8"
              style="margin-top: 15px"
            >
              <label>Contract ID: {{ code }}</label>
            </div>
            <div
              v-if="contractType == 'ProjectContract'"
              class="col-8"
              style="margin-top: 15px"
            >
              <label>Project ID</label>
              <select class="custom-select" v-model="selectedProject">
                <option
                  v-for="(project, key) in projects"
                  :key="key"
                  :value="project"
                >
                  {{ project.code }}
                </option>
              </select>
            </div>
            <div
              v-if="contractType == 'InvestorContract'"
              class="col-8"
              style="margin-top: 15px"
            >
              <label>Investor ID</label>
              <select
                :disabled="formType == 'update'"
                class="custom-select"
                v-model="selectedInvestor"
              >
                <option
                  v-for="(investor, key) in investors"
                  :key="key"
                  :value="investor"
                >
                  {{ investor.code }}
                </option>
              </select>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Contract Status</label>
              <select class="custom-select" v-model="status">
                <option
                  v-for="(status, key) in statusList"
                  :key="key"
                  :value="status.id"
                >
                  {{ status.name }}
                </option>
              </select>
            </div>
            <div
              class="col-8"
              style="
                display: flex;
                justify-content: space-around;
                margin-top: 20px;
              "
            >
              <div>
                <div>Start Date</div>
                <b-calendar
                  show-decade-nav
                  v-model="start_date"
                  locale="en-US"
                ></b-calendar>
              </div>
              <div>
                <div>End Date</div>
                <b-calendar
                  show-decade-nav
                  v-model="maturity_date"
                  locale="en-US"
                ></b-calendar>
              </div>
            </div>
            <div
              v-if="contractType == 'InvestorContract'"
              class="col-8"
              style="margin-top: 15px"
            >
              <label>Plan</label>
              <select class="custom-select" v-model="plan_id">
                <option
                  v-for="(plan, key) in plans"
                  :key="key"
                  :value="plan.id"
                >
                  {{ plan.name }}
                </option>
              </select>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Currency</label>
              <select class="custom-select" v-model="currency_id">
                <option
                  v-for="(currency, key) in currencies"
                  :key="key"
                  :value="currency.id"
                >
                  {{ currency.code }}
                </option>
              </select>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Initial Investment</label>
              <input
                class="form-control"
                type="text"
                required
                v-model="invested_principal"
              />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Payment Type</label>
              <select class="custom-select" v-model="payment_type">
                <option
                  v-for="(type, key) in paymentTypes"
                  :key="key"
                  :value="type.id"
                >
                  {{ type.name }}
                </option>
              </select>
            </div>
            <!-- <div class="col-8" style="margin-top: 15px">
              <label>Earnings Rate</label>
              <input class="form-control" type="text" required v-model="name" />
            </div> -->
            <!-- <div class="col-8" style="margin-top: 15px">
              <label>Description</label>
              <textarea
                class="form-control"
                type="text"
                required
                v-model="description"
              />
            </div> -->
          </div>
        </tab-content>
      </form-wizard>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import StoreInvestorContract from "../../../../storers/StoreInvestorContract";
import StoreProjectContract from "../../../../storers/StoreProjectContract";
import InvestorsFilter from "../../../../filters/InvestorsFilter";
import ProjectsFilter from "../../../../filters/ProjectsFilter";
import MediaBrowser from "../../../common/MediaBrowser.vue";
import InvestorContractsFilter from "../../../../filters/InvestorContractsFilter";
import ProjectContractsFilter from "../../../../filters/ProjectContractsFilter";

export default {
  props: {
    activeContractID: {
      type: Number,
      default: null,
    },
    activeProjectID: {
      type: Number,
      default: null,
    },
    activeInvestorID: {
      type: Number,
      default: null,
    },
    formType: {
      type: String,
      default: null,
    },
    contractType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      statusList: [
        { id: "active", name: "Active" },
        { id: "inactive", name: "InActive" },
        { id: "notstarted", name: "Not Started" },
        { id: "closed", name: "Closed" },
      ],
      paymentTypes: [
        { id: "cash", name: "Cash" },
        { id: "banktransfer", name: "Bank Transfer" },
        { id: "cheque", name: "Cheque" },
        { id: "blockchain", name: "Blockchain" },
      ],
      // Contract Details
      selectedInvestor: null,
      selectedProject: null,
      code: null,
      plan_id: null,
      invested_principal: null,
      currency_id: null,
      payment_type: null,
      start_date: null,
      maturity_date: null,
      signature_image: null,
      status: null,
    };
  },
  components: { MediaBrowser },
  created: function () {
    this.$store.dispatch("searchCurrencies");
    this.$store.dispatch("searchPlans");
    if (this.formType == "create") {
      if (this.contractType == "InvestorContract") {
        var investorsFilter = InvestorsFilter();
        this.$store.dispatch("searchInvestors", {
          filter: investorsFilter,
          resultMode: "default",
        });
      } else if (this.contractType == "ProjectContract") {
        var projectsFilter = ProjectsFilter();
        this.$store.dispatch("searchProjects", {
          filter: projectsFilter,
          resultMode: "default",
        });
      }
    }
    if (this.formType == "update") {
      var investorsFilter = InvestorsFilter();
      investorsFilter.ids = [this.activeInvestorID];
      this.$store.dispatch("searchInvestors", {
        filter: investorsFilter,
        resultMode: "default",
      });
      if (this.contractType == "InvestorContract") {
        var contractsFilter = InvestorContractsFilter();
        contractsFilter.ids = [this.activeContractID];
        this.$store
          .dispatch("searchInvestorContracts", {
            filter: contractsFilter,
            resultMode: "default",
          })
          .then(() => {
            this.fillForm();
          });
      } else if (this.contractType == "ProjectContract") {
        var projectsFilter = ProjectsFilter();
        projectsFilter.ids = [this.activeProjectID];
        this.$store.dispatch("searchProjects", {
          filter: projectsFilter,
          resultMode: "default",
        });
        var contractsFilter = ProjectContractsFilter();
        contractsFilter.ids = [this.activeContractID];
        this.$store
          .dispatch("searchProjectContracts", {
            filter: contractsFilter,
            resultMode: "default",
          })
          .then(() => {
            this.fillForm();
          });
      }
    }
  },
  computed: {
    ...mapState({
      plans: (state) => state.planStore.planSearch.plans,
      activeInvestorContract: (state) =>
        state.contractStore.investorContractSearch.investorContracts[0],
      activeProjectContract: (state) =>
        state.contractStore.investorContractSearch.investorContracts[0],
      countries: (state) => state.countryStore.countrySearch.countries,
      currencies: (state) => state.currencyStore.currencySearch.currencies,
      investors: (state) => state.investorStore.investorSearch.investors,
      projects: (state) => state.projectStore.projectSearch.projects,
    }),
  },
  methods: {
    init() {
      // Contract Details
      this.selectedInvestor = null;
      this.selectedProject = null;
      this.plan_id = null;
      this.invested_principal = null;
      this.payment_type = null;
      this.start_date = null;
      this.maturity_date = null;
      this.signature_image_id = null;
    },

    fillForm() {
      if (this.contractType == "InvestorContract") {
        this.code = this.activeInvestorContract.code;
        this.selectedInvestor = this.investors.find(
          (c) => c.id == this.activeInvestorContract.investor_id
        );
        this.plan_id = this.activeInvestorContract.plan_id;
        this.invested_principal =
          this.activeInvestorContract.invested_principal;
        this.payment_type = this.activeInvestorContract.payment_type;
        this.start_date = this.activeInvestorContract.start_date;
        this.maturity_date = this.activeInvestorContract.maturity_date;
        this.status = this.activeInvestorContract.status;
        this.currency_id = this.activeInvestorContract.currency_id;
        this.signature_image_id =
          this.activeInvestorContract.signature_image_id;
      } else if (this.contractType == "ProjectContract") {
        this.code = this.activeProjectContract.code;
        this.selectedProject = this.projects.find(
          (c) => c.id == this.activeProjectContract.project_id
        );
        this.selectedProject = this.activeProjectContract.selectedProject;
        this.plan_id = this.activeProjectContract.plan_id;
        this.invested_principal = this.activeProjectContract.invested_principal;
        this.payment_type = this.activeProjectContract.payment_type;
        this.start_date = this.activeProjectContract.start_date;
        this.maturity_date = this.activeProjectContract.maturity_date;
        this.status = this.activeProjectContract.status;
        this.currency_id = this.activeProjectContract.currency_id;
        this.signature_image_id = this.activeProjectContract.signature_image_id;
      }
    },

    newInvestorContractCode() {
      if (this.selectedInvestor.contracts_count + 1 < 10) {
        return (
          "YCC" +
          this.selectedInvestor.code.slice(2) +
          "0" +
          String(this.selectedInvestor.contracts_count + 1)
        );
      } else
        return (
          "YCC" +
          this.selectedInvestor.code.slice(2) +
          String(this.selectedInvestor.contracts_count + 1)
        );
    },
    newProjectContractCode() {
      if (this.selectedProject.contracts_count + 1 < 10) {
        return (
          "YPC" +
          this.selectedProject.code.slice(2) +
          "0" +
          String(this.selectedProject.contracts_count + 1)
        );
      } else
        return (
          "YPC" +
          this.selectedProject.code.slice(2) +
          String(this.selectedProject.contracts_count + 1)
        );
    },

    saveContract() {
      // Contract Details
      if (this.contractType == "InvestorContract") {
        var contract = StoreInvestorContract();
        if (this.formType == "update") {
          contract.id = this.activeInvestorContract.id;
          contract.code = this.activeInvestorContract.code;
          contract.investor_id = this.activeInvestorContract.investor_id;
        } else {
          contract.code = this.newInvestorContractCode();
          contract.investor_id = this.selectedInvestor.id;
        }
        contract.plan_id = this.plan_id;
      } else if (this.contractType == "ProjectContract") {
        var contract = StoreProjectContract();
        if (this.formType == "update") {
          contract.id = this.activeProjectContract.id;
          contract.code = this.activeProjectContract.code;
          contract.project_id = this.activeProjectContract.project_id;
        } else {
          contract.code = this.newProjectContractCode();
          contract.project_id = this.selectedProject.id;
        }
      }

      contract.status = this.status;
      contract.invested_principal = this.invested_principal;
      contract.currency_id = this.currency_id;
      contract.payment_type = this.payment_type;
      contract.start_date = this.start_date;
      contract.maturity_date = this.maturity_date;
      if (this.signature_image) {
        contract.signature_image_id = this.signature_image.id;
      }
      this.$emit("saveContract", contract);
    },
  },
  watch: {
    selectedInvestor() {
      if (this.selectedInvestor) {
        this.code = this.newInvestorContractCode();
      }
    },
    selectedProject() {
      if (this.selectedProject) {
        this.code = this.newProjectContractCode();
      }
    },
  },
};
</script>
<style>
.wizard-icon {
  color: rgb(140, 198, 63) !important;
}
.active .wizard-icon {
  color: rgb(255, 255, 255) !important;
}
.wizard-icon-circle {
  border-color: rgb(140, 198, 63) !important;
  background-color: #fafaf7 !important;
}
.stepTitle {
  color: rgb(140, 198, 63) !important;
  margin-top: 5px;
}
.form-control {
  border: 1px solid #ced4da !important;
  background-image: none;
  border-radius: 5px !important;
  padding: 10px;
}
.custom-select {
  background-color: transparent !important;
}
.wizard-btn {
  margin-bottom: 20px !important;
}
.vue-form-wizard.md .wizard-icon-circle {
  width: 100px;
  height: 100px;
  border-radius: 30px;
  font-size: 24px;
}
.vue-form-wizard .wizard-icon-circle .wizard-icon-container.square_shape {
  border-radius: 20px;
  padding: 32px;
}
.vue-form-wizard.md .wizard-nav-pills > li.active > a .wizard-icon {
  font-size: 34px;
}
.vue-form-wizard .wizard-icon-circle .wizard-icon {
  font-size: 34px;
}
.vue-form-wizard.md .wizard-navigation .wizard-progress-with-circle {
  display: none;
}
.vue-form-wizard .wizard-nav-pills > li.active > a {
  cursor: default;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/components/forms/contractForm.vue